import { createContext, useContext } from "react";

export interface ConfirmOptions {
  /** The question, already translated. */
  message: string;
  /** Optional heading, already translated. */
  title?: string;
  /** Label for the confirming button; defaults to "Confirm". */
  confirmLabel?: string;
  /** Red confirm button for destructive actions. */
  danger?: boolean;
}

export type ConfirmFn = (opts: ConfirmOptions | string) => Promise<boolean>;

export const ConfirmContext = createContext<ConfirmFn>(async (opts) =>
  window.confirm(typeof opts === "string" ? opts : opts.message),
);

/**
 * In-app replacement for window.confirm(): matches the dashboard's look,
 * follows the current language/direction and is keyboard accessible.
 *
 *   const confirm = useConfirm();
 *   if (!(await confirm({ message: t("Delete?", "حذف؟"), danger: true }))) return;
 */
export function useConfirm(): ConfirmFn {
  return useContext(ConfirmContext);
}
